import * as React from "react";
import { Alert, Text, TextLink } from "@origin-digital/ods-core";
import { getMultisiteAgreementCopy } from "./multisiteAgreementContent";

interface MultisiteAgreementAlertProps {
  service: string;
}

const MultisiteAgreementAlert: React.FC<MultisiteAgreementAlertProps> = ({
  service,
}) => (
  <Alert>
    <Text>
      {getMultisiteAgreementCopy(service).map(({ content, link }) => (
        <React.Fragment key={content}>
          {content}
          {link && (
            <TextLink
              href={link.url}
              target="_blank"
              domProps={{
                rel: "noopener noreferrer",
                "aria-label": link.ariaLabel,
              }}
            >
              {link.label}
            </TextLink>
          )}
        </React.Fragment>
      ))}
    </Text>
  </Alert>
);

export default MultisiteAgreementAlert;
